<template>
    <div>
        <h4 class="text-secondary mb-2.5 font-bold">
            目前的年金給付方式
        </h4>
        <div class="w-full xs:text-lg px-3 py-3.5 divide-y divide-dashed">
            <div class="grid grid-cols-2 md:grid-cols-3 table-space max-w-[45rem]">
                <div>契約始期</div>
                <div>{{ formatToTwDate(effectDate) }}</div>
            </div>
            <!-- <hr class="border-gray-100 border-dashed"> -->
            <div
                v-if="isShowPayDate"
                class="grid grid-cols-2 md:grid-cols-3 table-space max-w-[45rem]"
            >
                <div>年金給付開始日</div>
                <div>{{ formatToTwDate(payDate) }}</div>
            </div>
            <!-- <hr class="border-gray-100 border-dashed "> -->
            <div
                v-if="isShowPayWay"
                class="grid grid-cols-2 md:grid-cols-3 table-space max-w-[45rem]"
            >
                <div>年金給付方式</div>
                <div>{{ payWayText }}</div>
            </div>
            <!-- <hr class="border-gray-100 border-dashed "> -->
            <div
                v-if="isShowPayPeriod"
                class="grid grid-cols-2 md:grid-cols-3 table-space max-w-[45rem]"
            >
                <div>年金給付期間</div>
                <div>{{ payPeriod }}年</div>
            </div>
            <!-- <hr class="border-gray-100 border-dashed "> -->
            <div
                v-if="isShowEnsurePeriod"
                class="grid grid-cols-2 md:grid-cols-3 table-space max-w-[45rem]"
            >
                <div>年金保證期間</div>
                <div>{{ ensurePeriod }}年</div>
            </div>
        </div>
    </div>
</template>

<script>
import { formatToTwDate } from '@/utils/is/dateUtils';

export default {
    props: {
        effectDate: {
            type: String,
            default: '',
        },
        isShowPayDate: {
            type: Boolean,
            required: true,
        },
        payDate: {
            type: String,
            default: '',
        },
        isShowPayWay: {
            type: Boolean,
            required: true,
        },
        payWayText: {
            type: String,
            default: '',
        },
        isShowPayPeriod: {
            type: Boolean,
            required: true,
        },
        payPeriod: {
            type: String,
            default: '',
        },
        isShowEnsurePeriod: {
            type: Boolean,
            required: true,
        },
        ensurePeriod: {
            type: String,
            default: '',
        },
    },
    setup(props) {
        return { formatToTwDate };
    }
};
</script>
<style scoped lang="scss">
.max-width {
    @apply w-full sm:max-w-[30rem] md:max-w-[24rem];
}
.border-style {
    @apply border-t border-dashed border-gray-200 min-h-[3rem] md:min-h-[4.25rem] items-center flex py-2.5 md:py-3.5;
}
.table-space {
    @apply py-2.5 first:pt-0 last:pb-0;
}
</style>
